
<mat-stepper class="stepper">

    <mat-step>
        <ng-template matStepLabel>Amazon</ng-template>
        <amazon-item [amazonItems]="amazonItems" *ngIf="amazonItems"></amazon-item>
        <div class="action-btn-container">
            <span *ngIf="!amazonItems || amazonItems.numberOfResults === 0">No Amazon Items for {{ search }}</span>
            <button mat-raised-button color="primary" (click)="checkPrice(amazonItems)" [disabled]="!amazonItems || amazonItems.numberOfResults === 0">Check Price</button>
            <button mat-raised-button color="warn" [routerLink]="['/']" >Back</button>
        </div>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>Ebay</ng-template>
        <ebay-browse-item [ebayBrowseItems]="ebayBrowseItems" *ngIf="ebayBrowseItems"></ebay-browse-item>
        
        <div class="action-btn-container">
            <span *ngIf="!ebayBrowseItems || ebayBrowseItems.itemSummaries.length === 0">No Ebay Items for {{ search }}</span>
            <button mat-raised-button color="primary" (click)="checkPrice(amazonItems)" [disabled]="!amazonItems || amazonItems.numberOfResults === 0">Check Price</button>
            <button mat-raised-button color="warn" [routerLink]="['/']">Back</button>
        </div>
    </mat-step>
   
</mat-stepper>



